// extracted by mini-css-extract-plugin
export default {"container":"styles-module--container--3G1ap","type":"styles-module--type--28YtV"};